import { render } from "./LearningQuestion.vue?vue&type=template&id=23c7dc2c&scoped=true"
import script from "./LearningQuestion.vue?vue&type=script&lang=js"
export * from "./LearningQuestion.vue?vue&type=script&lang=js"

import "./LearningQuestion.vue?vue&type=style&index=0&id=23c7dc2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c7dc2c"]])

export default __exports__